<template>
    <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state" :disabled="disabled">
        <b-form-checkbox v-model="inputVal">
            {{ chkLabel }}
        </b-form-checkbox>
    </b-form-group>
</template>

<script>
    export default {
        props: ['chkLabel', 'label', 'model', 'attribute', 'errors','errorOnly', 'disabled'],
        data() {
            return {inputVal: this.model[this.attribute] ? this.model[this.attribute] : null, state: null, errorTxt: ''}
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val[this.attribute];
                }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model[this.attribute] = val;
                this.$emit("change");
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                            return;
                        }
                    });
                }
                if (!this.errorOnly) {
                    this.state = !hasErr;
                }
            }
        },
    }
</script>